import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAPI } from "../../service/http-service";
import { CommonEndpoint } from "../../service/endpointConfig/CommonEndpoint";
import { CommonUtil } from "../../util/Utils";

let initialState: any = {
  stateResponse: {},
};

// Get State API call
export const StateService = createAsyncThunk(
  "master/state",
  async (state: any) => {
    try {
      return await getAPI(
        `${CommonEndpoint.state}${CommonUtil.appendQueryStr(
          state?.ids,
          "regionIds"
        )}`
      );
    } catch (err) {
      return err;
    }
  }
);

const stateSlice = createSlice({
  name: "state",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      StateService.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload?.status;
        state.error = "";
        state.data = action.payload?.data?.data;
      }
    );
    builder.addCase(StateService.rejected, (state, action) => {
      state.loading = false;
      state.status = -1;
      state.error = action.error.message || "Something went wrong";
      state.data = {};
    });
  },
});

const stateReducer = stateSlice.reducer;
export default stateReducer;
